import { LastCaseStudies, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import type { AdditionalInfoProps } from '../CaseStudy.types';

import {
  StyledStack,
  StyledTestimonial,
  GlowStack,
  AdditionalInfoSection,
  TestimonialWrapper,
  StyledQuote,
} from './styles';
export const AdditionalInfo: FC<AdditionalInfoProps> = ({
  testimonial,
  lastCaseStudies,
}) => {
  return (
    <AdditionalInfoSection width="normal" borderTopOn>
      <GlowStack />

      {testimonial && testimonial.text && (
        <StyledStack>
          <NameBanner text="Customer's testimonial" type="section" />
          <StyledQuote variant="display_sm">“</StyledQuote>
          <TestimonialWrapper>
            <StyledTestimonial
              avatarSrc={testimonial.avatarSrc}
              name={testimonial.name}
              positionInCompany={testimonial.positionInCompany}
              text={testimonial.text}
            />
          </TestimonialWrapper>
        </StyledStack>
      )}

      {lastCaseStudies && (
        <LastCaseStudies
          secondCaseStudy={lastCaseStudies.secondCaseStudy}
          firstCaseStudy={lastCaseStudies.firstCaseStudy}
        />
      )}
    </AdditionalInfoSection>
  );
};
